export const  MOVIES =  [
      {
  
        "isbn": "9781593275846",
  
        "title": "Eloquent JavaScript, Second Edition",
  
        "subtitle": "A Modern Introduction to Programming",
        
        "categories": ['javascript', 'advanced', 'modern'],
  
        "author": "Marijn Haverbeke",
  
        "published": "2014-12-14T00:00:00.000Z",
  
        "publisher": "No Starch Press",
  
        "pages": 472,
  
        "description": "JavaScript lies at the heart of almost every modern web application, from social apps to the newest browser-based games. Though simple for beginners to pick up and play with, JavaScript is a flexible, complex language that you can use to build full-scale applications.",
  
        "website": "http://eloquentjavascript.net/",

        "score": 4,

        "year": 2000,

        "image": "https://eloquentjavascript.net/2nd_edition/img/cover.png",
  
      },
  
      {
  
        "isbn": "9781449331818",
  
        "title": "Learning JavaScript Design Patterns",
  
        "subtitle": "A JavaScript and jQuery Developer's Guide",

        "categories": ['javascript', 'beginner', 'modern'],
  
        "author": "Addy Osmani",
  
        "published": "2012-07-01T00:00:00.000Z",
  
        "publisher": "O'Reilly Media",
  
        "pages": 254,

        "year": 2000,
  
        "description": "With Learning JavaScript Design Patterns, you'll learn how to write beautiful, structured, and maintainable JavaScript by applying classical and modern design patterns to the language. If you want to keep your code efficient, more manageable, and up-to-date with the latest best practices, this book is for you.",
  
        "website": "http://www.addyosmani.com/resources/essentialjsdesignpatterns/book/",

        "score": 3,

        "image": "https://addyosmani.com/resources/essentialjsdesignpatterns/cover/cover.jpg",
  
      },
  
      {
  
        "isbn": "9781449365035",
  
        "title": "Speaking JavaScript",
  
        "subtitle": "An In-Depth Guide for Programmers",

        "categories": ['javascript', 'advanced', 'browser'],
  
        "author": "Axel Rauschmayer",
  
        "published": "2014-02-01T00:00:00.000Z",
  
        "publisher": "O'Reilly Media",
  
        "pages": 460,

        "year": 2000,
  
        "description": "Like it or not, JavaScript is everywhere these days-from browser to server to mobile-and now you, too, need to learn the language or dive deeper than you have. This concise book guides you into and through JavaScript, written by a veteran programmer who once found himself in the same position.",
  
        "website": "http://speakingjs.com/",

        "score": 5,

        "image": "http://speakingjs.com/es5/orm_front_cover.jpg",

  
      },
  
      {
  
        "isbn": "9781491950296",
  
        "title": "Programming JavaScript Applications",
  
        "subtitle": "Robust Web Architecture with Node, HTML5, and Modern JS Libraries",

        "categories": ['javascript', 'aplications'],
  
        "author": "Eric Elliott",
  
        "published": "2014-07-01T00:00:00.000Z",
  
        "publisher": "O'Reilly Media",
  
        "pages": 254,
        
        "year": 2000,

        "description": "Take advantage of JavaScript's power to build robust web-scale or enterprise applications that are easy to extend and maintain. By applying the design patterns outlined in this practical book, experienced JavaScript developers will learn how to write flexible and resilient code that's easier-yes, easier-to work with as your code base grows.",
  
        "website": "http://chimera.labs.oreilly.com/books/1234000000262/index.html",

        "score": 2,

        "image": "https://www.oreilly.com/library/cover/9781491950289/360h",

  
      },
  
      {
  
        "isbn": "9781593277574",
  
        "title": "Understanding ECMAScript 6",
  
        "subtitle": "The Definitive Guide for JavaScript Developers",

        "categories": ['javascript', 'developers'],
  
        "author": "Nicholas C. Zakas",
  
        "published": "2016-09-03T00:00:00.000Z",
  
        "publisher": "No Starch Press",
  
        "pages": 352,

       "year": 2000,
  
        "description": "ECMAScript 6 represents the biggest update to the core of JavaScript in the history of the language. In Understanding ECMAScript 6, expert developer Nicholas C. Zakas provides a complete guide to the object types, syntax, and other exciting changes that ECMAScript 6 brings to JavaScript.",
  
        "website": "https://leanpub.com/understandinges6/read",

        "score": 3,

        "image": "https://d2sofvawe08yqg.cloudfront.net/understandinges6/small?1558023536",

  
      },
  
      {
  
        "isbn": "9781491904244",
  
        "title": "You Don't Know JS",
  
        "subtitle": "ES6 & Beyond",

         "categories": ['es6', 'javascript'],
  
        "author": "Kyle Simpson",
  
        "published": "2015-12-27T00:00:00.000Z",
  
        "publisher": "O'Reilly Media",
  
        "pages": 278,

       "year": 2000,
  
        "description": "No matter how much experience you have with JavaScript, odds are you don’t fully understand the language. As part of the 'You Don’t Know JS' series, this compact guide focuses on new features available in ECMAScript 6 (ES6), the latest version of the standard upon which JavaScript is built.",
  
        "website": "https://github.com/getify/You-Dont-Know-JS/tree/master/es6%20&%20beyond",

        "score": 4,

       "image": "https://images-na.ssl-images-amazon.com/images/I/B14vD2o4sDS._SY300_.png",

      },


      {
  
        "isbn": "9780321812186",
  
        "title": "Effective JavaScript: 68 Specific Ways to Harness the Power of JavaScript",
  
        "subtitle": "Effective Software Development Series",
  
        "author": "David Herman",

        "categories": ['javascript', 'effective'],
  
        "published": "2015-12-27T00:00:00.000Z",
  
        "publisher": "O'Reilly Media",
  
        "pages": 325,

        "year": 2000,
  
        "description": "It’s uncommon to have a programming language wonk who can speak in such comfortable and friendly language as David does.",
  
        "website": "https://github.com/getify/You-Dont-Know-JS/tree/master/es6%20&%20beyond",

        "score": 3,

       "image": "data:image/webp;base64,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",

      },


      {
  
        "isbn": "9780596517748",
  
        "title": "JavaScript: The Good Parts",
  
        "subtitle": "Effective Software Development Series",

         "categories": ['foo'],
  
        "author": "Douglas Crockford",
  
        "published": "2015-12-27T00:00:00.000Z",
  
        "publisher": "O'Reilly Media",
  
        "pages": 222,
  
        "description": "Most programming languages contain good and bad parts, but JavaScript has more than its share of the bad, having been developed and released in a hurry before it could be refined.",
  
        "website": "https://github.com/getify/You-Dont-Know-JS/tree/master/es6%20&%20beyond",

        "score": 5,

       "year": 2000,

       "image": "https://images-na.ssl-images-amazon.com/images/I/5131OWtQRaL._SX381_BO1,204,203,200_.jpg",

      },



      {
  
        "isbn": "9780596517748",
  
        "title": "JavaScript Allongé",
  
        "subtitle": "Programming from Functions to Classes in ECMAScript 2015",
  
        "author": "Reg “raganwald” Braithwaite",
  
        "published": "2015-12-27T00:00:00.000Z",
  
        "publisher": "O'Reilly Media",


        "categories": ['javascript', 'allongé'],
  
        "pages": 222,
  
        "description": "A long pull of functions, combinators, & decorators, written in modern JavaScript.",
  
        "website": "https://github.com/getify/You-Dont-Know-JS/tree/master/es6%20&%20beyond",

        "score": 3,

       "year": 2000,

       "image": "https://d2sofvawe08yqg.cloudfront.net/javascriptallongesix/hero?1556305743",

      },



      {
  
        "isbn": "9780596517748",
  
        "title": "Node.js in Action",
  
        "subtitle": "Programming from Functions to Classes in ECMAScript 2015",
  
        "author": "Mike Cantelon, Marc Harter",
  
        "published": "2015-12-27T00:00:00.000Z",

        "categories": ['Node', 'action'],
  
        "publisher": "Manning Publications",
  
        "pages": 334,

        "year": 2000,
  
        "description": "If you do not want to confine yourself to the client-side JavaScript and want to explore the true power of JavaScript with Node.js",
  
        "website": "https://github.com/getify/You-Dont-Know-JS/tree/master/es6%20&%20beyond",

        "score": 3,

       "image": "https://stackabuse.s3.amazonaws.com/media/best-javascript-books-for-all-skill-levels-8.jpg",

      },




      {
  
        "isbn": "9781118026694",
  
        "title": "Professional JavaScript for Web Developers",
  
        "subtitle": "Programming from Functions to Classes in ECMAScript 2015",
  
        "author": "Nicholas C. Zakas",

         "categories": ['zakas', 'action'],
  
        "published": "2015-12-27T00:00:00.000Z",
  
        "publisher": "O'Reilly Media",
  
        "pages": 222,

        "year": 2000,
  
        "description": "JavaScript use with HTML to create dynamic webpages, language concepts including syntax and flow control statements",
  
        "website": "https://github.com/getify/You-Dont-Know-JS/tree/master/es6%20&%20beyond",

        "score": 4,

       "image": "https://images-na.ssl-images-amazon.com/images/I/51TYgNA8Y-L._SX351_BO1,204,203,200_.jpg",

      },



      {
  
        "isbn": "9780596004675",
  
        "title": "JavaScript & DHTML Cookbook",
  
        "subtitle": "On numerous online forums for JavaScript and DHTML, the majority of questions begin with How do I...?",
  
        "author": "Mike Cantelon, Marc Harter",

         "categories": ['javaScript', 'html'],
  
        "published": "2015-12-27T00:00:00.000Z",
  
        "publisher": "Manning Publications",
  
        "pages": 425,

        "year": 2000,
  
        "description": "On numerous online forums for JavaScript and DHTML, the majority of questions begin with How do I...? This new Cookbook provides the answers. After reading thousands of forum threads over the years, author and scripting pioneer Danny Goodman has compiled a list of problems that frequently vex scripters of various experience levels. He has now applied state-of-the-art ECMA and W3C DOM standards and used best practices to create this extensive collection of practical recipes that can bring your web pages to life.",
  
        "website": "https://github.com/getify/You-Dont-Know-JS/tree/master/es6%20&%20beyond",

        "score": 4,

       "image": "https://images-na.ssl-images-amazon.com/images/I/51pv73hLLpL._SX379_BO1,204,203,200_.jpg",

      },
];